import ComponentsInput from 'components/Input'
import Link from 'components/Link'
import styled from 'styled-components'
import { color, theme } from 'utils'

export const Expanded = styled.div`
  border-radius: ${theme('inputBorderRadius')};
  border: 1px solid ${color('dark700')};
  padding: 0.375rem 0.5rem;
  margin-right: 2.5rem;
`

export const AddressWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
`

export const InputWrapper = styled.div`
  position: relative;
  label {
    color: ${color('white')};
  }

  div:last-child {
    position: absolute;
    right: 8px;
    bottom: 11px;
  }
`

export const Input = styled(ComponentsInput)`
  input {
    text-overflow: ellipsis;
    padding-right: 2rem;
    background: transparent;
    color: ${color('white')};
    border: 2px solid ${color('dark500')};

    &:active:not(:disabled),
    &:focus:not(:disabled) {
      background: transparent;
      color: ${color('grey100')};
      border-color: ${color('dark200')};
    }
  }
`

export const Spacer = styled.div`
  margin-top: 0.5rem;
`

export const MemoContainer = styled.div`
  position: relative;
`

export const MemoLink = styled(Link)`
  position: absolute;
  right: 0;
  top: 0.25rem;
  z-index: 1;
`

export const CryptoWrapper = styled.div`
  margin: 1rem 0 0 0;
`
